<template>
   <div class="loader" v-if="globalLoading">
      <div class="loader-block">
         <div></div>
         <div></div>
         <div></div>
         <div></div>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      globalLoading: {
         type: Boolean,
         required: true,
      },
   },
};
</script>
